<template>
  <svg
    width="32"
    height="36"
    viewBox="0 0 32 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89438 32.3098L1.59195 34.4621L0.999878 12.9424L10.4737 9.35596L11.0657 31.9516L21.3285 35.0001L30.9999 31.7719L30.8023 10.6115L21.4918 13.1251L21.3285 32.947"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.1921 26.5223C16.1921 26.5223 10.1979 16.781 9.76348 9.51494C9.25056 0.94335 21.5937 1.23882 21.8623 8.01019C22.1309 14.7816 16.2451 21.1679 16.2451 21.1679"
      stroke="#B1A8D3"
      stroke-width="4.75992"
      stroke-miterlimit="10"
    />
    <path
      d="M15.6975 11.4849C16.9077 11.4849 17.8888 10.5259 17.8888 9.34291C17.8888 8.15993 16.9077 7.20093 15.6975 7.20093C14.4873 7.20093 13.5062 8.15993 13.5062 9.34291C13.5062 10.5259 14.4873 11.4849 15.6975 11.4849Z"
      fill="#462170"
      stroke="#462170"
      stroke-width="1.24615"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
